import { _ } from '../model/ccc'
import type { IPerson } from '../model/IPerson'
import { Relationship } from '../model/Relationship'
import { getRelationshipName } from './getRelationshipName'

const OMIT_DESCRIPTION_RE = /:.*$/g

export function getPersonRelationshipFormatted(person: IPerson) {
	if (
		person.relationship === Relationship.Parditka ||
		person.relationship === Relationship.Related
	)
		return ''
	let name
	switch (person.relationship) {
		case Relationship.Parent:
			name = person.isMale
				? `Apa: egy Parditka édesapja.`
				: `Anya: egy Parditka édesanyja.`
			break
		case Relationship.Spouse:
			name = person.isMale
				? `Férj: egy Parditka férje.`
				: `Feleség: egy Parditka felesége.`
			break
		default:
			name = getRelationshipName(person.relationship)
	}
	return (
		<span class={_.ccc_tag__relationship} title={name}>
			{name.replace(OMIT_DESCRIPTION_RE, '')}
		</span>
	)
}
